import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/explorer/backend-readiness/page.tsx");
